import { createSelector } from 'reselect';

const stateSelector = state => state.profile;

export const firstNameSelector = createSelector(
  stateSelector,
  profile => profile.firstname
);

export const lastNameSelector = createSelector(
  stateSelector,
  profile => profile.lastname
);

export const emailSelector = createSelector(
  stateSelector,
  profile => profile.email
);
